<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="goods-detail-dialog" top="15vh" width="1100px" :fullscreen="isExpand" :show-close="false" :before-close="handleClose">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>查看商品</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-descriptions :colon="false" :column="3" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
        <el-descriptions-item label="商品编码sku">{{ detail.sn || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detail.goodsName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品别名">{{ detail.anotherName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="型号">{{ detail.model || '--' }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ detail.simpleSpecs || '--' }}</el-descriptions-item>
        <el-descriptions-item label="计量单位">{{ detail.goodsUnit || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品分类">{{ detail.merchantGoodsCategoryName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品品牌">{{ detail.brandName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="原厂备件号">{{ detail.storeSn || '--' }}</el-descriptions-item>
        <el-descriptions-item label="医疗件属性">{{ detail.medicalFlag ? '医疗件' : '非医疗件' }}</el-descriptions-item>
        <el-descriptions-item label="注册证号/备案凭证号">{{ detail.registerCode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="质保期/保修期">{{ `${detail.qualityAssPeriod || ''}${ detail.qualityAssPeriod && detail.qualityAssPeriodUnitName ? detail.qualityAssPeriodUnitName : ''}` || '--' }}</el-descriptions-item>
        <el-descriptions-item label="适配设备" :span="3">
          <template v-if="detail.deviceType === '1' && detail.deviceList && detail.deviceList.length">
            <span>{{ detail.deviceList.map(item => `${item.deviceName}_${item.deviceBrandName}_${item.deviceModel}`).join('，') }}</span>
          </template>
          <template v-else-if="detail.deviceType === '2'">通用</template>
          <template v-else>--</template>
        </el-descriptions-item>
        <el-descriptions-item label="商品图片" :span="3">
          <template>
            <div v-if="detail.skuImages && detail.skuImages.length">
              <el-image
                v-for="(url, i) in detail.skuImages"
                :key="'licence-'+i"
                :src="url"
                :preview-src-list="detail.skuImages"
                style="width: 88px; height: 88px; margin-right: 10px; margin-bottom: 10px;">
              </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-descriptions-item>
      </el-descriptions>

      <div style="padding: 10px 20px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="日志" name="logs"></el-tab-pane>
          <el-tab-pane v-if="detail.medicalFlag" label="产品注册证" name="register"></el-tab-pane>
        </el-tabs>

        <xz-table v-if="activeName === 'logs'" ref="xzTable" :columns="logColumns" :data="logData" rowKey="id"></xz-table>

        <el-descriptions v-if="detail.medicalFlag && activeName === 'register'" :colon="false" :column="3" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
          <el-descriptions-item label="医疗器械分类">{{ registerInfo.medicalPathName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册人/备案人/代理人">{{ registerInfo.registrantName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册证号/备案凭证号">{{ registerInfo.registrationCode || '--' }}</el-descriptions-item>
          <el-descriptions-item label="批准备案日期">{{ registerInfo.approvalDate ? formatDate(registerInfo.approvalDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="有效期至">{{ registerInfo.effectiveDate ? formatDate(registerInfo.effectiveDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="管理类别">{{ getCategoryLabel(registerInfo.category) }}</el-descriptions-item>
          <el-descriptions-item label="厂商名称">{{ registerInfo.manufacturerName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="厂商地区" :span="2">{{ `${registerInfo.originProvinceName || ''}${registerInfo.originCityName || ''}${registerInfo.originAreaName || ''}` || '--' }}</el-descriptions-item>
          <el-descriptions-item label="产品注册证/备案凭证图片" :span="3">
            <div v-if="registerInfo.annexList && registerInfo.annexList.length">
              <el-image
                v-for="(annex, i) in registerInfo.annexList"
                :key="'licence-'+i"
                :src="annex.url"
                :preview-src-list="registerInfo.annexList.map(annex => annex.url)"
                style="width: 88px; height: 88px; margin-right: 10px; margin-bottom: 10px;">
              </el-image>
            </div>
            <template v-else>--</template>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as Moment from 'dayjs';
import { skuDetail, operationLog } from '@/api/goods';
import { registerProductDetail } from '@/api/registerNo';
import { categoryList } from '@/enums/managerCategoryEnum';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
export default {
  components: {
    xzTable,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  watch: {
    dialogVisible (v) {
      if (v && this.id) {
        this.activeName = 'logs';
        this.queryGoodsDetail();
        this.queryOperationLogs();
      }
    },
  },
  data () {
    return {
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      activeName: 'logs',
      detail: {},
      registerInfo: {},
      logData: [],
      logColumns: [
        {
          title: '日志类型',
          dataIndex: 'sourceDesc',
          key: 'sourceDesc',
          width: 120,
        },
        {
          title: '事件类型',
          dataIndex: 'eventTypeDesc',
          key: 'eventTypeDesc',
          width: 120,
        },
        {
          title: '创建人',
          dataIndex: 'createUserName',
          key: 'createUserName',
          width: 120,
        },
        {
          title: '发生时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          width: 180,
          customRender: (text) => {
            return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          title: '日志内容',
          dataIndex: 'content',
          key: 'content',
        },
      ],
    };
  },
  methods: {
    formatDate (text, format = 'YYYY-MM-DD') {
      const day = text ? Moment(text * 1).format(format) : '/';
      return day === '9999-12-31' ? '永久' : day;
    },
    getCategoryLabel (v) {
      return categoryList.find(item => item.value === v)?.label || '--';
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleClick () {
      if (this.activeName === 'logs') {
        this.queryOperationLogs();
      }
      if (this.activeName === 'register') {
        this.queryRegisterDetail();
      }
    },
    async queryOperationLogs () {
      if (!this.id) return;
      const { body } = await operationLog({
        businessId: this.id,
        module: 'GOODS',
        businessType: 'BASE_SKU',
        pageFlag: false,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
      });
      this.logData = body?.list || [];
    },
    async queryRegisterDetail () {
      const { body } = await registerProductDetail({ registrationCode: this.detail.registerCode });
      this.registerInfo = body || {};
    },
    async queryGoodsDetail () {
      const { body } = await skuDetail({id: this.id, findDeviceFlag: true});
      this.detail = body || {};
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-detail-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
}
/deep/ .descriptionsLabel {
  width: 100px;
  text-align: right;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #929aa6;
  letter-spacing: 0;
  text-align: right;
  line-height: 20px;
}
/deep/ .descriptionsValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1f2733;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
  display: flex;
  flex-direction: column;
}
</style>
